import Listar from '../views/Listar'
const routes = [
    {
        name: 'listarMdfeEmissor',
        path: '/emissor/manifestos',
        alias: ['/emissor/manifestos/index'],
        component: Listar,
    },
]

export default routes
